

import Vue from 'vue'
import Component from "vue-class-component";
import {UrlHelper} from "@/helpers/UrlHelper";
import {
  EOrderPaymentStatuses,
  EOrderStatuses,
  EOrderTypes,
  IOrder,
  IOrderPromotion,
  IOrderService
} from "@/model/Order/orderInterfaces";
import {Prop} from "vue-property-decorator";
import {TranslationHelper} from "@/helpers/TranslationHelper";
import {OrderHelper} from "@/helpers/OrderHelper";
import LinkChip from "@/components/shared/chips/LinkChip.vue";
import {IOnOffHandlers} from "bonomo/dist";
import {EPermissionActions} from "@/model/EPermissionActions";
import {BetterDataTableHeader} from "@/model/betterVuetifyInterfaces";

@Component({
  components: {LinkChip}
})
export default class OOServices extends Vue {

  @Prop()
  protected order!: IOrder;
  @Prop()
  protected submitting!: boolean;

  private subscribes: IOnOffHandlers = {};

  protected get headers(): BetterDataTableHeader[] {
    return [
      { text: this.canProcess ? this.$t('orders.services.processed') : '',
        align: 'start', sortable: false, value: 'processed' },
      { text: this.$t('orders.services.name'), align: 'start', sortable: false, value: 'name' },
      { text: this.$t('orders.services.quantity'), align: 'center', sortable: false, value: 'quantity' },
      { text: this.$t('orders.services.sub_total'), align: 'end', sortable: false, value: 'sub_total' },
      { text: '', align: 'end', value: 'control' },
    ];
  }

  protected get typeDropOnly(): boolean {
    return this.order.type === EOrderTypes.drop_only;
  }

  protected get firstItem(): any {
    return this.order.services[0];
  }
  protected get items(): any[] {
    let ret: any[] = [];
    if (this.order) {
      ret = ret.concat(this.order.services.filter(each => !each.service || !each.service.mandatory));
      ret = ret.concat(this.order.services.filter(each => each.service && each.service.mandatory));
      if (this.order.delivery_costs > 0) {
        ret.push({
          type: 'delivery',
          name: this.$t('orders.order.delivery_costs'),
          // quantity: '',
          item_price: this.order.delivery_costs,
          sub_total: this.order.delivery_costs,
        });
      }
      this.order.promotions.forEach(
        (each: IOrderPromotion) => ret.push({
          type: 'promotion',
          name: this.$t('orders.order.promotion'),
          quantity: each.promotion.promo_code,
          sub_total: -each.discount,
          promotion: each.promotion,
        })
      );
      if (this.order.rentback_amount && this.order.rentback_amount > 0) {
        ret.push({
          type: 'rentback',
          name: this.$t('orders.order.rentback'),
          sub_total: -this.order.rentback_amount,
        });
      }
    }
    ret.push({
      type: 'total',
    });
    return ret;
  }

  protected get orderCanBeProcessed(): boolean {
    return !this.order.deleted_at &&
        this.order.status != EOrderStatuses.status_order_completed;
  }
  protected get canConfirm(): boolean {
    return OrderHelper.canConfirm(this.order) &&
        this.$canAction('orders/process');
  }
  protected get canEdit(): boolean {
    return this.$canAction(EPermissionActions.ACTION_ORDERS_UPDATE) &&
        this.order.status !== EOrderStatuses.status_order_completed &&
        this.order.payment_status !== EOrderPaymentStatuses.status_payment_paid &&
        this.order.payment_status !== EOrderPaymentStatuses.status_payment_paid_invoice;
  }
  protected get editOrderRoute(): object {
    return { name: 'orderEdit', params: { orderId: String(this.order.id) } };
  }

  protected get canProcess(): boolean {
    return OrderHelper.canProcess(this.order) &&
        this.$canAction(EPermissionActions.ACTION_ORDERS_PROCESS);
  }
  protected get allProcessed(): boolean {
    return !this.order.services.find(each => !each.processed);
  }

  protected itemName(item: IOrderService) {
    if (item.type == 'total') {
      return '';
    }
    else if (item.name) {
      return item.name;
    }
    else if (item.service && item.service.name) {
      return TranslationHelper.translateField(item.service.name);
    }
    return '???';
  }

  protected promotionUrl(promotionId: number): string {
    return UrlHelper.mayorPromotion(promotionId);
  }

  protected onConfirmOrder() {
    this.$emit('confirmOrder');
  }

  protected onAllProcessed() {
    this.$emit('allProcessed');
  }

  protected onProcessedClicked(item: IOrderService) {
    this.$emit('serviceProcessed', {orderServiceId: item.id, processed: !item.processed});
  }

}

